import { Form } from "reactstrap";
import CommonFileUpload from "src/CommonElements/CommonFileUpload";

const DropzoneFile = () => {
  return (
    <Form>
      <CommonFileUpload />
    </Form>
  );
};

export default DropzoneFile;
